import { DrawerEmployees } from './DrawerEmployees';
import { DrawerEmployeesProvider } from './DrawerEmployees.context';
import { DrawerEmployeesProps } from './DrawerEmployees.types';

export const DrawerEmployeesWrapper = ({
	employees,
	onClose,
}: DrawerEmployeesProps): JSX.Element => {
	return (
		<DrawerEmployeesProvider employees={employees} onClose={onClose}>
			<DrawerEmployees />
		</DrawerEmployeesProvider>
	);
};
